module.exports = __webpack_public_path__ + "img/co1.8a094d46.png";